import { FormControl, FormGroup, AbstractControl,  ValidatorFn } from '@angular/forms';

export class CustomValidator {

  static email(control: FormControl) {

    // tslint:disable-next-line:max-line-length
    const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return EMAIL_REGEXP.test(control.value) ? null : {
      validateEmail: {
        valid: false
      }
    };
  }

  static whitespace(control: FormControl) {

    const pattern = /^[^\s]+(\s+[^\s]+)*$/;

    return pattern.test(control.value) ? null : {
      noWhitespace: {
        valid: false
      }
    };
  }

  static number(control: FormControl) {

    const pattern = /^[0-9]+(\.[0-9]*){0,1}$/g;

    return pattern.test(control.value) ? null : {
      validateNumber: {
        valid: false
      }
    };
  }

  static password(control: FormControl) {

    const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#\$%\^&\*])[A-Za-z\d]{4,20}/;
    return pattern.test(control.value) ? null : {
      invalidPassword: {
        valid: false
      }
    };
  }

  static minLengthArray(min: number) {
    return (c: AbstractControl): {[key: string]: any} => {
      if (c.value.length >= min) {
        return null;
      }
      return { 'minLengthArray': {valid: false }};
    }
  }

  static creditCardValidator(control) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
      return null;
    } else {
      return { 'invalidCreditCard': true };
    }
  }

  static pricingField(control: FormControl) {

    const pattern = /^[0-9]+(\.[0-9]*){0,1}$/g;

    return (pattern.test(control.value) || control.value === '+') ? null : {
      validatePricingField: {
        valid: false
      }
    };
  }

  static confirmPassword(formGP: FormGroup) {
    const password = formGP.controls.password.value;
    const repeatPassword = formGP.controls.confirmPassword.value;

    if (repeatPassword.length <= 0) {
      return null;
    }

    if (repeatPassword !== password) {
      return {
        doesMatchPassword: true
      };
    }

    return null;
  }

}
